export default class C5RetiradaItemModel {
  public lojaId: string = "";
  public dataEntrega: Date = new Date();
  public ScheduleID: string = "";
  public DeliveryCapacity: number = 5;
  public DeliveryHour: string = "";
  public DeliveryDate: Date = new Date();

  public static toModel(item: any): C5RetiradaItemModel {
    return {
      ScheduleID: item.ScheduleID,
      lojaId: item.StoreID,
      DeliveryCapacity: item.DeliveryCapacity,
      DeliveryHour: item.DeliveryHour,
      DeliveryDate: item.DeliveryDate
    } as C5RetiradaItemModel;
  }
}